<template>
  <div>
    <a
      :href="link"
      target="_blank"
      rel="noopener noreferrer"
      class="article-card-container"
      @click="$emit('link-click', { link, headline })"
    >
      <div class="article-image-container">
        <ArticleCardATSImage :file-name="imageFileName" />
      </div>
      <div class="article-body">
        <h3 class="article-pre-headline">
          {{ preHeadline }}
        </h3>
        <h3>
          {{ headline }}
        </h3>
        <p class="article-description">
          {{ description }}
        </p>
      </div>
    </a>
  </div>
</template>

<script setup>
import ArticleCardATSImage from '@/components/insights/ProcessInsights/DemographicSurveyReport/ArticleCardATSImage.vue';

defineProps({
  preHeadline: {
    type: String,
    required: true,
  },
  imageFileName: {
    type: String,
    required: true,
  },
  headline: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    required: true,
  },
});

defineEmits(['link-click']);
</script>

<style scoped lang="less">
.article-card-container {
  width: 214px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background: @white;
  border-radius: 8px;
  border: 1px solid @stroke-default;
  cursor: pointer;

  &:hover h3:not(.article-pre-headline) {
    color: @text-brand;
  }

  h3 {
    font-size: 13px;
    color: @text-darkest;
    font-weight: 500;
    line-height: normal;

    &.article-pre-headline {
      line-height: 150%;
      color: @text-lighter;
      margin-bottom: 4px;
    }
  }

  .article-body {
    padding: 16px;
  }

  .article-image-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: 134px;

    .article-image {
      width: 100%;
      border-radius: 4px;
      margin-top: 16px;
      margin-bottom: 12px;
    }
  }

  .article-description {
    font-size: 12px;
    color: @text-light;
    line-height: 145%;
    font-weight: 400;
    margin: 4px 0px;
  }
}
</style>
